module.exports = __webpack_public_path__ + "img/desktop-neck-17_452x18.35640861.png";